import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {
    httpRequestAccountDeletion,
    RequestAccountDeletionPayload,
    RequestAccountDeletionResponse
} from './accountDeletion.http'

export const useRequestAccountDeletion = (
    options?: UseMutationOptions<RequestAccountDeletionResponse, unknown, RequestAccountDeletionPayload>
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.REQUEST_ACCOUNT_DELETION],
        mutationFn: httpRequestAccountDeletion
    })
